import Image_Default from "../../images/man.png";
import { useState,useEffect } from "react";
import {connect} from "react-redux";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getRoom } from "../../redux/actions/actions.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

const Messages_Search_Followings_User = (props) => {
    const navigate = useNavigate();
    const [user,setUser] = useState([]);
    const params = useParams();

    useEffect(() => {
        getUser(props.user_id)
    },[])
    const getUser = (id) => {
        fetch(`/user?q=${id}`)
        .then(res => res.json())
        .then(data => {
            setUser(data[0])
        })
        .catch(error => console.log(error))
    }
    const handleClick = async() => {
        try {
            const response = await axios.post("/newroom",{
                user_one_id:params.id,
                user_two_id:user.id
            },{
                withCredentials:true,
                headers:{
                    "Content-Type":"application/json"
                }
            });
            props.onGetRoom(params.id,user.id);
            console.log(props.room);
        } catch (error) {
            console.log(error);
        }
    }
    const goToProfile = async () => {
        try {
            const result = await axios.post("/room",{
                user_one_id:params.id,
                user_two_id:user.id
            },{
                withCredentials:true,
                headers:{
                    "Content-Type":"application/json"
                }
            });
            // navigate(`/profile/${user.id}`);
        } catch (error) {
            console.log(error);
        }
    }
    return(
        <div className={`messages_room background_change_hover background_change_hover_${props.color_background}`} onClick={goToProfile}>
            <img src={Image_Default} alt="User" className="messages_room_user_image" />
            <div className={`messages_room_main_add main_content_section_${props.color_background}`}>
                <div className="message_room_middle">
                    <div className="messages_room_userinfo">{user.firstName} {user.lastName}</div>
                    <div className={`messages_room_content messages_room_content_${props.color_background}`}>{`@${user.userName}`}</div>
                </div>
                <button className={`messages_room_button_add_div profile_customize_section_color_button_${props.color_button}`} onClick={handleClick}>
                    <FontAwesomeIcon className="messages_room_button_add" icon={faPlus} />
                </button>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        room: state.getRoom.room,
        color_background: state.getColorBackground.color_background,
        color_button: state.getColorButton.color_button,
        isPending: state.getRoom.isPending,
        error: state.getRoom.error
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onGetRoom: (user_one,user_two) => dispatch(getRoom(user_one,user_two))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Messages_Search_Followings_User);